import { QueryClient } from '@tanstack/angular-query-experimental';

// Everything a step or segment reorder can change on the server: the definition itself, plus the rules,
// blockers and action details the properties sidebars keep cached. A reorder may remove rules from
// steps and actions that are not on screen, so a sidebar left open would otherwise show stale data
// until the user selects another item.
const REORDER_AFFECTED_QUERY_KEYS = [
  'Workflow',
  'Segment',
  'SegmentConditionals',
  'SegmentBlockers',
  'Step',
  'StepConditionals',
  'StepBlockers',
  'Action',
  'ActionConditionals',
  'ActionBlockers',
] as const;

/** Marks the queries above stale and refetches the ones in use; resolves when those refetches finish. */
export async function invalidateReorderQueries(
  queryClient: QueryClient
): Promise<void> {
  await Promise.all(
    REORDER_AFFECTED_QUERY_KEYS.map(key =>
      queryClient.invalidateQueries({ queryKey: [key] })
    )
  );
}
